import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Link } from 'react-router-dom';

import { hideResidentsCheck } from '../../utilities/Generic.js'
import { request, handleRequestErrors } from '../../helpers/Requests'

class PeopleTotals extends Component {
  render() {
    let { people, loaded, error, unauthorized, hideResidents } = this.state;

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (loaded === false) {
      return <p>Loading ...</p>;
    }

    if (loaded) {
      if (hideResidents) {
        people = people.filter(type_of_person => type_of_person.name !== "Resident")
      }

      return (
        <div className="widget">
          <div className="table big-table">
            <div className="tr heading">
              <div className="th">Type of person</div>
              <div className="th">Number</div>
              <div className="th">Last used</div>
            </div>
            {people.map((person) => (
               <Link to={`/people?location=${this.props.id}&type=${person.name.toLowerCase()}`} key={person.name} className="tr">
                <div className="td bold">{person.name}</div>
                <div className="td">{person.count}</div>
                <div className="td">{person.last_used}</div>
              </Link>
            ))}
          </div>
        </div>
      );
    }
  }

  state = {
    people: [],
    hideResidents: hideResidentsCheck(),
    loaded: false,
    error: null
  };

  componentDidMount() {
    let id = this.props.id;

    request("GET", `/v1/a/locations/${id}/people_totals`, "", () => {this.setState({unauthorized: true})})
      .then(data => this.setState({ people: data, loaded: true }))
      .catch(error => handleRequestErrors(this, error, { loaded: true }))
  }
}

export default PeopleTotals;
